import { useLazyGetGraphQuery } from "@store/services/graphsService"
import { atom, useAtom } from "jotai"
import { useCallback, useEffect, useState } from "react"

export const allLinkedGraphValidationsErrorsAtom = atom<string[]>([])

type TriggerGetGraph = (graphKey: string) => Promise<{ error?: unknown }>

export const getAllLinkedGraphValidationErrors = async (
  graphKeys: string[],
  triggerGetGraph: TriggerGetGraph,
) => {
  const collectErrors = new Set<string>()

  for (const graphKey of graphKeys) {
    const graph = await triggerGetGraph(graphKey)

    if (graph.error) {
      collectErrors.add(`Linked Graph not found: ${graphKey}`)
    }
  }

  return Array.from(collectErrors)
}

export const useAllLinkedGraphValidations = (graphKeys: string[]) => {
  const [isValidating, setIsValidating] = useState(false)
  const [errors, setErrors] = useAtom(allLinkedGraphValidationsErrorsAtom)
  const [triggerGetGraph] = useLazyGetGraphQuery()

  const runValidation = useCallback(async () => {
    setIsValidating(true)
    setErrors([])

    try {
      const validationErrors = await getAllLinkedGraphValidationErrors(graphKeys, triggerGetGraph)
      setErrors(validationErrors)
    } finally {
      setIsValidating(false)
    }
  }, [graphKeys, setErrors, triggerGetGraph])

  useEffect(() => {
    runValidation()
  }, [runValidation])

  return { isValidating, errors }
}
